var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBlockchain = function SvgBlockchain(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.64,
    height: 31.488,
    viewBox: "0 0 36.64 31.488",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blockchain_white",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    fill: "currentColor",
    d: "M26.908,33.6l7.9-2.634-7.9-2.634-7.9,2.634Zm1.145,2.061v10.42l8.588-2.863V32.795Zm-2.29,0-8.588-2.863v10.42l8.588,2.863ZM7.443,31.821l5.611-1.889L7.443,28.1,1.832,29.932l5.611,1.889ZM6.3,33.882,0,31.764v7.729l6.3,2.118V33.882Zm2.29,0v7.729l6.3-2.118V31.764l-6.3,2.118Z",
    transform: "translate(0 -10.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    fill: "currentColor",
    d: "M25.443,8.221,31.11,6.332,25.443,4.5,19.832,6.332ZM24.3,10.282,18,8.164v7.729l6.3,2.118Zm2.29,0v7.729l6.3-2.118V8.164Z",
    transform: "translate(-7.695)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlockchain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blockchain.fa7f6eca.svg";
export { ForwardRef as ReactComponent };